import React from "react";
import { Box, Stack } from "@mui/material";
import CclDrawer from "../../../../../../../components/common/cclDrawer/cclDrawer";
import CclButton from "../../../../../../../components/common/cclButtons/cclButton";
import CclDrawerActionBar from "../../../../../../../components/common/cclDrawer/cclDrawerActionBar";
import SelfLegendTable from "./selfLegendTable";
import ScorableLegendTable from "./scorableLegendTable";
import RaterLegendTable from "./raterLegendTable";

export type AssessmentStatusLegendDrawerProps = {
    open: boolean;
    onClose: () => void;
};

const AssessmentStatusLegendDrawer: React.FC<AssessmentStatusLegendDrawerProps> = (props) => {
    return (
        <CclDrawer
            open={props.open}
            onClose={props.onClose}
            title="Assessment Status Legend"
            width="standard"
        >
            <Box>
                <Stack spacing={2}>
                    <SelfLegendTable />
                    <ScorableLegendTable />
                    <RaterLegendTable />
                    <CclDrawerActionBar>
                        <CclButton onClick={props.onClose} mode={"primary"}>
                            Close
                        </CclButton>
                    </CclDrawerActionBar>
                </Stack>
            </Box>
        </CclDrawer>
    );
};

export default AssessmentStatusLegendDrawer;
